import { observable, computed, action, runInAction } from 'mobx';
import { asyncAction } from 'mobx-utils';
import autobind from 'autobind-decorator';
import StarcraftModel from './model';
import StarcraftSetModel from './model/set';
import { setEsportsDefaultList } from '../../shared/utils';
import useLocalStorage from '../../../../hooks/useLocalStorage';
import { timeUtils } from '../../../../common/utils/timeUtil';
import WebSocketUtil from '../../../../common/utils/socketUtil';
import { ScoreUtil } from '../../../../common/utils/scoreUtil';
import { ScoreService } from '../../../../common/services';
import AbstractScoreCommon from '../../store/common';

@autobind
class StarcraftStore extends AbstractScoreCommon {
  localstorage = new useLocalStorage();
  socket = null;
  isSub = false;

  @observable
  list = [];

  @observable
  loading = false;

  @observable
  mapRecord = {
    view: false,
    selectedMapId: null,
    data: false,
    loading: false
  };

  constructor() {
    super();
    const today = timeUtils.todayYmd();
  }

  connectSocket(topic) {
    this.socket = new WebSocketUtil(topic);

    this.socket.ws.onmessage = (event) => {
      if (event) {
        let data = event.data;

        try {
          if (data === 'OK') {
            this.isSub = true;
          } else {
            let messageData = JSON.parse(data);

            if (messageData) {
              const { TOPIC, MESSAGE } = messageData;

              if (TOPIC.includes('star')) {
                const data = JSON.parse(MESSAGE);
                const copy = [...this.list.toJS()];
                let index = null;

                if (data.hasOwnProperty('gidx')) {
                  index = copy.findIndex((item) => item.id === data.gidx);
                }

                if (TOPIC === `esports.star.games`) {
                  this.list[index].updateGame(data);
                }

                if (TOPIC === 'esports.star.period') {
                  this.list[index].updatePeriod(data);
                }

                if (TOPIC === `sports.star.cheers`) {
                  index = copy.findIndex((item) => item.id == data.game_id);
                  if (Boolean(~index)) {
                    this.list[index].cheerCount++;
                  }
                }
              }
            }
          }
        } catch (error) {
          console.log('=== socket on message error ===', error);
        }
      }
    };
  }

  /**********************************************************
   * computed
   **********************************************************/
  @computed
  get starcraftList() {
    const list = this.list.toJS();

    let copy = [...list];

    const sortedGames = ScoreUtil.eSportsStarSortList(copy);

    return setEsportsDefaultList(sortedGames);
  }
  /**********************************************************
   * actions
   **********************************************************/
  @action
  closeSocket() {
    this.socket.close(() => {
      runInAction(() => {
        this.isSub = false;
        this.socket = null;
      });
    });
  }

  /**********************************************************
   * async actions
   **********************************************************/
  @asyncAction
  *getStarcraft(date) {
    this.loading = true;

    try {
      // TODO: 웹소켓;
      if (!this.isSub) {
        yield this.connectSocket([
          'esports.star.games',
          'esports.star.period',
          'sports.star.cheers'
        ]);
      }

      const result = yield ScoreService.getEsportsTypeGames(
        date,
        'ALL',
        'star'
      );

      if (result) {
        // console.log(result);

        this.list = result.map((item) => {
          const deep = { ...item };

          if (deep.set.length > 0) {
            deep.set = item.set.map((set) => {
              let setDeep = { ...set };

              return new StarcraftSetModel(setDeep);
            });
          }

          deep['id'] = item.gidx;

          return new StarcraftModel(deep);
        });

        this.loading = false;
      }
    } catch (error) {
      console.log(error);
    }
  }
}

export default StarcraftStore;
